/*=========================================================================================
  File Name: module-usertax-getters.js
  Description: UserTax Module Getters
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import commonFunction from '@/common/commonFunction';
import { isNullOrEmpty } from '@/common/objectUtil';

export default {
	getAllTreeOrganizations(state) {
		return state.AllTreeOrganizations || [];
	},
	getAllOrganizations(state) {
		return state.AllOrganizations || [];
	},
	getOrganizationUnits(state) {
		return state.OrganizationUnits || [];
	},
	getOrganizationUnitsTotal(state) {
		return state.OrganizationUnits.length;
	},
	getOrganizationWorking(state) {
		return state.OrganizationWorking;
	},
	getOrganizationInSubscriber(state) {
		return state.SubscriberWorking.Organizations;
	},
	getOrganizationGuideStatus(state) {
		return state.organizationGuide;
	},
	getSubscriberWorking(state) {
		return state.SubscriberWorking;
	},
	hiddenTips(state) {
		return state.hiddenTips;
	},
	Total(state) {
		if (state.Organizations && state.Organizations.length > 0) {
			return state.Organizations.length;
		} else {
			return 0;
		}
	},
	// getTransactionHistory(state) {
	//     if( state.Organization.ChangeHistories == null || state.Organization.ChangeHistories == undefined ) return []
	//     return  state.Organization.ChangeHistories
	// },
	// getOrganizationInfo(state){
	//     return state.Organization
	// },
	/**
	 * Lấy danh sách chi nhánh, phòng ban để build kiểu tree
	 */
	getOrganizationList(state) {
		return state.Organizations;
	},
	isExistsInvRevEmail(state) {
		let organizationWorking = state.OrganizationWorking;
		if (organizationWorking && !isNullOrEmpty(organizationWorking.InvRevEmail)) {
			return true;
		}
		return false;
	},
	getViewTourGuide(state) {
		return state.viewTourGuide;
	},

	showPaymentWarnings(state) {
		return state.ShowPaymentWarnings;
	},

	showConnectTaxaxions(state) {
		return state.ShowConnectTaxaxions;
	},

	isShowConnectTaxaxion(state) {
		return state.IsShowConnectTax;
	},

	isShowLostConnectTaxaxion(state) {
		return state.IsShowLostConnectTaxaxion;
	},

	isShowInvoiceRiskBySupplier(state) {
		return state.IsShowInvoiceRiskBySupplier;
	},
	getFullTreeOrganizations(state) {
		return state.FullTreeOrganizations || [];
	},
	isCheckThirdParty(state) {
		return state.OrganizationWorking && state.OrganizationWorking.IsCheckThirdParty;
	}
};
